// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PFdr","comment":"styles_comment__2bMxy"};